import { useState, useRef, useEffect } from "react";
import { ResultMessage } from "../components/ResultMessage";
import { errorMessage } from "./useRequest";

enum SocketState {
    Connecting = 0,
    Ready = 1,
    Closing = 2,
    Closed = 3
}

interface Options {
    url: string;
    onMessage?(msg: any): void;
}

const useWebsocket = ({ url, onMessage }: Options) => {
    const ws = useRef<WebSocket | null>(null);

    //  socket 状态
    const [readyState, setReadyState] = useState<{
        key: SocketState;
        value: string;
    }>({ key: SocketState.Connecting, value: "正在连接中" });

    const creatWebSocket = () => {
        const stateArr = [
            { key: SocketState.Connecting, value: "正在连接中" },
            { key: SocketState.Ready, value: "已经连接并且可以通讯" },
            { key: SocketState.Closing, value: "连接正在关闭" },
            { key: SocketState.Closed, value: "连接已关闭或者没有连接成功" }
        ];

        try {
            ws.current = new WebSocket(url);

            ws.current.onopen = () => {
                setReadyState(stateArr[ws.current?.readyState ?? 0]);
            };

            ws.current.onclose = () => {
                setReadyState(stateArr[ws.current?.readyState ?? 0]);
            };

            ws.current.onerror = () => {
                setReadyState(stateArr[ws.current?.readyState ?? 0]);
            };
            ws.current.onmessage = e => {
                try {
                    const message = JSON.parse(e.data);
                    onMessage?.(message);
                    // setMessage({ ...JSON.parse(e.data) });
                } catch (e) {}
            };
        } catch (error) {
            ResultMessage.error(errorMessage(error));
        }
    };

    const webSocketInit = () => {
        if (!ws.current || ws.current.readyState === SocketState.Closed) {
            creatWebSocket();
        }
    };

    //  关闭 WebSocket
    const closeWebSocket = () => {
        ws.current?.close();
    };

    // 发送数据
    const sendMessage = (str: string) => {
        ws.current?.send(str);
    };

    //重连
    const reconnect = () => {
        try {
            closeWebSocket();
            ws.current = null;
            creatWebSocket();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    useEffect(() => {
        webSocketInit();
        return () => {
            ws.current?.close();
        };
    }, []);

    //如果连接断开则重连
    useEffect(() => {
        if (readyState.key === SocketState.Closed) {
            reconnect();
        }
    }, [readyState]);

    //wsData （获得的 socket 数据）、readyState（当前 socket 状态）、closeWebSocket （关闭 socket）、reconnect（重连）
    return {
        readyState,
        closeWebSocket,
        reconnect,
        sendMessage
    };
};
export default useWebsocket;
